// Reenvía los parámetros de tracking (UTM + click IDs) que llegan a la landing
// hacia la URL de checkout externa.

// Parámetros que se propagan tal cual desde la URL de la landing.
const FORWARDED_PARAMS = [
  'utm_source',
  'utm_medium',
  'utm_campaign',
  'utm_content',
  'utm_term',
  'fbclid',
  'gclid',
] as const

/**
 * Devuelve la baseUrl con los parámetros de tracking presentes en la URL actual
 * de la landing agregados como query string (sin modificar sus valores).
 *
 * - Si la landing no tiene ninguno de esos parámetros, devuelve baseUrl sin cambios.
 * - Es segura para SSR: si `window` no existe, devuelve baseUrl tal cual.
 */
export function getCheckoutUrl(baseUrl: string): string {
  if (typeof window === 'undefined') return baseUrl

  const current = new URLSearchParams(window.location.search)
  const forwarded = new URLSearchParams()

  for (const key of FORWARDED_PARAMS) {
    const value = current.get(key)
    if (value !== null) {
      forwarded.set(key, value)
    }
  }

  const query = forwarded.toString()
  if (!query) return baseUrl

  // Respeta un posible query string ya existente en baseUrl.
  const separator = baseUrl.includes('?') ? '&' : '?'
  return `${baseUrl}${separator}${query}`
}
